import { submit, supplement, getList, checkType, department,
  checkBody, checkProject, imageRoom, RegisterPatient, AppendProcedure,
  UpdateProcedure, DeleteProcedure, UpdateRegister, Patients, UpdateRegisterBaseInfo, GetHisRegisters } from '@/api/register'
// import { fail } from 'assert'
import { fleZipUploadFile, GetUploadImagesRecordsByHospId, GetHospInfo } from '@/api/upload'
const register = {
  state: {
    checkList: {
      checkType: [], // 登记设备类型
      checkBody: [], // 登记检查部位
      checkProject: [] // 登记检查项目
    },
    regID: '',
    departments: [],
    imageRoom: [],
    imageRoomList: [],
    supList: [],
    registerList: [],
    regpatient: [],
    infor: {
      add: '',
      upDate: '',
      del: ''
    },
    patients: [],
    HisRegisterList: []
  },
  mutations: {
    SET_REGISTER: (state, registerStaus) => {
      state.registerStaus = registerStaus
    },
    GET_PATIENTS: (state, patients) => {
      state.patients = patients
    },
    GET_REGISTERLIST: (state, registerList) => {
      state.registerList = registerList
    },
    SET_REGID: (state, regID) => {
      state.regID = regID
    },
    GET_DEPARTMENT: (state, departments) => { // 科室字典
      state.departments = departments
    },
    GET_CHECKTYPE: (state, checkType) => { // 设备类型字典
      state.checkList.checkType = checkType
    },
    GET_CHECKBODY: (state, checkBody) => { // 检查部位字典
      state.checkList.checkBody = checkBody
    },
    GET_CHECKPROJECT: (state, checkProject) => { // 检查项目字典
      state.checkList.checkProject = checkProject
    },
    GET_IMAGEROOM: (state, imageRoom) => { // 影像室字典
      state.imageRoom = imageRoom
    },
    GET_IMAGEROOMLIST: (state, imageRoom) => { // 影像室字典
      state.imageRoomList = imageRoom
    },
    GET_REGISTERINFO: (state, datas) => { // 影像室字典
      state.regpatient = datas
    },
    SET_HISLIST: (state, datas) => {
      state.HisRegisterList = datas
    },
    SET_INFOR: (state, data, flag) => {
      if (flag === 1) {
        state.infor.add = data
      }
      if (flag === 2) {
        state.infor.upDate = data
      }
      if (flag === 3) {
        state.infor.del = data
      }
    }
  },
  actions: {
    saveRegistration({ commit }, data) { // 提交登记
      return new Promise((resolve, reject) => {
        submit(data).then(response => {
          const data = response.data
          commit('SET_REGISTER', data) // 保存登记状态
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    patients({ commit }, data) { // 复诊病人列表
      return new Promise((resolve, reject) => {
        Patients(data).then(response => {
          const data = response.data
          commit('GET_PATIENTS', data) // 病人列表
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveSupplement({ commit }, data) { // 补登登记
      return new Promise((resolve, reject) => {
        supplement(data).then(response => {
          const data = response.data
          commit('SET_REGISTER', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getregisterList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getList(data).then(response => {
          const data = response.data
          commit('GET_REGISTERLIST', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getdepartment({ commit }, params) {
      return new Promise((resolve, reject) => {
        department(params).then(response => {
          const data = response.data
          commit('GET_DEPARTMENT', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getcheckType({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkType(data).then(response => {
          const data = response.data
          commit('GET_CHECKTYPE', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getcheckBody({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkBody(data).then(response => {
          const data = response.data
          commit('GET_CHECKBODY', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getcheckProject({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkProject(data).then(response => {
          const data = response.data
          commit('GET_CHECKPROJECT', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getimageRoom({ commit }, data) {
      return new Promise((resolve, reject) => {
        imageRoom(data).then(response => {
          const data = response.data
          commit('GET_IMAGEROOM', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getimageRoomList({ commit }, data) {
      return new Promise((resolve, reject) => {
        imageRoom(data).then(response => {
          const data = response.data
          commit('GET_IMAGEROOMLIST', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getRegisterPatient({ commit }, data) {
      return new Promise((resolve, reject) => {
        RegisterPatient(data).then(response => {
          const data = response.data
          commit('GET_REGISTERINFO', data)
          resolve()
        }).catch(error => {
          commit('GET_REGISTERINFO', [])
          reject(error)
        })
      })
    },
    appendProcedure({ commit }, data) {
      return new Promise((resolve, reject) => {
        AppendProcedure(data).then(response => {
          const data = response.data
          const flag = 1
          commit('SET_INFOR', data, flag)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateProcedure({ commit }, data) {
      return new Promise((resolve, reject) => {
        UpdateProcedure(data).then(response => {
          const data = response.data
          const flag = 2
          commit('SET_INFOR', data, flag)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteProcedure({ commit }, data) {
      return new Promise((resolve, reject) => {
        DeleteProcedure(data).then(response => {
          const data = response.data
          const flag = 3
          commit('SET_INFOR', data, flag)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateRegister({ commit }, data) {
      return new Promise((resolve, reject) => {
        UpdateRegister(data).then(response => {
          const data = response.data
          commit('SET_REGISTER', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateRegisterBaseInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        UpdateRegisterBaseInfo(data).then(response => {
          const data = response.data
          commit('SET_REGISTER', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    saveRegID({ commit }, data) {
      return new Promise((resolve, reject) => {
        // UpdateRegister(data).then(response => {
        //   const data = response.data
        //   commit('SET_REGISTER', data)
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
        commit('SET_REGID', data)
      })
    },
    getHisRegisters({ commit }, data) {
      return new Promise((resolve, reject) => {
        GetHisRegisters(data).then(response => {
          const data = response.data
          commit('SET_HISLIST', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    FleZipUploadFile({ commit }, data) {
      return new Promise((resolve, reject) => {
        fleZipUploadFile(data).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUploadImagesRecordsByHospId({ commit }, data) {
      return new Promise((resolve, reject) => {
        GetUploadImagesRecordsByHospId(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getHospInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        GetHospInfo(data).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default register
